import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";

if (environment.sentryEnabled) {
  Sentry.init({
    dsn: environment.sentryDsn,
    sendDefaultPii: true,
    integrations: [
    ],
  });
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
